import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SponsorSubjectsStorage } from '../sponsor-subjects-storage';
import { findSelectedStudy } from '../../shared/route-helpers';
import { SponsorSubjectIdentity } from '../sponsor-subject-item';

@Injectable()
export class SponsorSubjectIdentitiesResolver implements Resolve<Observable<SponsorSubjectIdentity[]>> {

    constructor(
        private readonly sponsorSubjectsStorage: SponsorSubjectsStorage,
    ) { }

    public resolve(route: ActivatedRouteSnapshot): Observable<SponsorSubjectIdentity[]> {
        const selectedStudy = findSelectedStudy(route);
        return this.sponsorSubjectsStorage.loadSubjectIdentitiesByStudy(selectedStudy);
    }
}